import Input from 'components/Input';
import { useTranslate } from 'hooks/translation-hooks';

const defaultName = 'lastName';

const LastName = ({ register, errors, variation, title }) => {
  const t = useTranslate('caseOpening');
  const name = variation ? `${defaultName}${variation}` : defaultName;
  return (
    <Input
      {...register(name, {
        required: true,
        pattern: /^.{2,}$/,
      })}
      error={errors[name] && 'case_identification-last_name_error_format'}
      label={t(title || 'case_identification-last_name')}
      placeholder={t('case_identification-last_name-placeholder')}
      testId="lastName"
    />
  );
};

export default LastName;
